import { render, staticRenderFns } from "./FirmOrderDetail.vue?vue&type=template&id=4a2120a1&"
import script from "./FirmOrderDetail.vue?vue&type=script&lang=js&"
export * from "./FirmOrderDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports